import { createFeature, createReducer, on } from "@ngrx/store";
import { StoreStatus } from "@utility/state";
import { loadUser, loadUserFailure, loadUserSuccess, saveUser, saveUserFailure, saveUserSuccess } from "./user.actions";
import { UserState } from "./user.state";

const initialState: UserState = {
	userId: "",
	firstName: "",
	lastName: "",
	fullName: "",
	email: "",
	logoutUrl: "",
	status: StoreStatus.PENDING,
	error: undefined
};

export const UserFeature = createFeature({
	name: "user",
	reducer: createReducer(
		initialState,
		on(loadUser, (state) => ({
			...state,
			status: StoreStatus.LOADING
		})),
		on(loadUserSuccess, (state, { user }) => ({
			...state,
			userId: user.id,
			firstName: user.firstName,
			lastName: user.lastName,
			fullName: user.fullName,
			email: user.email,
			logoutUrl: user.logoutUrl,
			error: undefined,
			status: StoreStatus.SUCCESS
		})),
		on(loadUserFailure, (state, error) => ({
			...state,
			userId: "",
			firstName: "",
			lastName: "",
			fullName: "",
			email: "",
			logoutUrl: "",
			error: error.error,
			status: StoreStatus.ERROR
		})),
		on(saveUser, (state) => ({
			...state,
			status: StoreStatus.LOADING
		})),
		on(saveUserSuccess, (state, { firstName, lastName }) => ({
			...state,
			firstName,
			lastName,
			fullName: `${firstName} ${lastName}`,
			error: undefined,
			status: StoreStatus.SUCCESS
		})),
		on(saveUserFailure, (state) => ({
			...state,
			status: StoreStatus.ERROR
		}))
	),
	extraSelectors: ({ selectStatus, selectFullName, selectEmail, selectError, selectFirstName, selectLastName }) => ({
		selectUserStatus: selectStatus,
		selectName: selectFullName,
		selectUserEmail: selectEmail,
		selectUserFirstName: selectFirstName,
		selectUserLastName: selectLastName,
		selectUserError: selectError
	})
});

export const {
	selectUserState,
	selectUserId,
	selectLogoutUrl,
	selectUserStatus,
	selectName,
	selectUserEmail,
	selectUserFirstName,
	selectUserLastName,
	selectUserError
} = UserFeature;
